import SearchMdIcon from '@untitled-ui/icons-react/build/esm/SearchMd';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import SvgIcon from '@mui/material/SvgIcon';
import { useEffect, useState } from 'react';
import loader from 'src/components/LoaderImg/loader.gif';

const Search = ({
  setSearchData,
  searchData = '',
  placeholder = '',
  setPage = (value: any) => {},
  loading = false,
}: any) => {
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    let timerOut: any;
    timerOut = setTimeout(() => {
      if (searchData === '') setPage(0);
      setSearchData(searchTerm);
    }, 1500);

    return () => clearTimeout(timerOut);
  }, [searchTerm]);

  return (
    <OutlinedInput
      defaultValue=""
      fullWidth
      value={searchTerm}
      onChange={(event) => setSearchTerm(event.target.value)}
      // inputProps={{ ref: queryRef }}
      placeholder={placeholder}
      startAdornment={
        <InputAdornment position="start">
          <SvgIcon>
            <SearchMdIcon />
          </SvgIcon>
        </InputAdornment>
      }
      endAdornment={
        loading && (
          <InputAdornment position="end">
            <img
              height={40}
              src={loader}
            />
          </InputAdornment>
        )
      }
    />
  );
};

export default Search;
